/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subscription_Withdrawal_Page_TitleInputs */

const de_subscription_withdrawal_page_title = /** @type {(inputs: Subscription_Withdrawal_Page_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Widerruf erklären`)
};

/** @type {(inputs: Subscription_Withdrawal_Page_TitleInputs) => LocalizedString} */
const en_subscription_withdrawal_page_title = de_subscription_withdrawal_page_title;

/**

* @param {Subscription_Withdrawal_Page_TitleInputs} inputs
* @param {{ locale?: "de" | "en" }} options
* @returns {LocalizedString}
*/
export const subscription_withdrawal_page_title = /** @type {((inputs?: Subscription_Withdrawal_Page_TitleInputs, options?: { locale?: "de" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subscription_Withdrawal_Page_TitleInputs, { locale?: "de" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_subscription_withdrawal_page_title(inputs)
	return en_subscription_withdrawal_page_title(inputs)
});